/** @module store/state */
export const STORAGE_KEY = 'tavolinuxApp'

/** stato auth iniziale */
let syncedData = {
  auth: {
    isLoggedIn: false,
    accessToken: null
  },
  currentListino: null
}

/** stato iniziale */
const notSyncedData = {
  loading_queue: [],

  prodVarIngr: [],
  tags: [],
  menu: [],
  tavoli: [],
  listini: [],
  allergeni: [],

  user: null,

  terminals: [],
  operators: [],

  //variable to control loading spinner

  load_state: {
    user: false,
    pvi: false,
    tags: false,
    menu: false,
    tavoli: false,
    listini: false,
    allergeni: false,
    terminals: false,
    operators: false,
    operators_rights: false,
    
    //TODO: 
    paymentTypes: false,
    discountTypes: false
  },

  userRightsTemplate: [],
  
  toolbarActions: [],
  toolbarTitle: null,

  lastError: null,
  lastMessage: null,

  lock: false,
  changed: false,

  libSelectedTab: 'prod',

  filters: {
    lib: {
      specific: null,
      selected: null
    },
    prodSelector: {
      specific: null,
      selected: null
    }
  },

  lingue: [ {value: 'IT', name: 'Italiano', flag: 'it', disabled: true},
            {value: 'EN', name: 'Inglese', flag: 'gb', disabled: false},
            {value: 'DE', name: 'Tedesco', flag: 'de', disabled: false},
            {value: 'FR', name: 'Francese', flag: 'fr', disabled: false},
            {value: 'ES', name: 'Spagnolo', flag: 'es', disabled: false},
            {value: 'NL', name: 'Olandese', flag: 'nl', disabled: false}
          ],
            //disabled ==> italiano unica lingua non deselezionabile

  // payment type array
  paymentTypes: [],

  // discount type array
  discountTypes: [],

  
  //version control object 
  
  dataVersions: {
    paymentTypes: '',
    terminals: '',
    operators: '',
    discountTypes: ''
  }
}

export const originalState = JSON.parse(JSON.stringify(Object.assign({}, syncedData, notSyncedData)))

// Sync with local storage.
if (localStorage.getItem(STORAGE_KEY)) {
  syncedData = JSON.parse(localStorage.getItem(STORAGE_KEY))
}

// Merge data and export it.
export const state = Object.assign(syncedData, notSyncedData)


// WEBPACK FOOTER //
// ./src/store/state.js